import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { patchOperations } from 'utils/PatchHelper'
import { captureException } from 'utils/SentryHelpers'
import { api } from './api'
import app from 'containers/app'
import * as actions from './actions'
import * as selectors from './selectors'
import * as selectorsUI from './selectorsUI'
import * as SocketConstants from 'app/modules/socket/constants'

function fetchCampaign(action$, { getState }) {
  return action$
    .ofType(actions.fetchCampaign.toString())
    .map(action => action.payload)
    .filter(({ id }) => selectors.fetchStatus(id)(getState()) !== actions.fetchCampaignPending.toString())
    .filter(({ id, force }) => !selectors.isCampaignFetched(id)(getState()) || force)
    .mergeMap(({ id }) => {
      return api
        .fetch(id)
        .takeUntil(action$.ofType(actions.fetchCampaign))
        .map(actions.receiveCampaign)
        .startWith(actions.fetchCampaignPending({ id }))
        .catch(error => {
          captureException(error)
          return Observable.of(actions.fetchCampaignFailed({ id, error }))
        })
    })
}

function updateCampaign(action$, { getState }) {
  return action$.ofType(actions.updateCampaign.toString())
    .map(action => action.payload)
    .mergeMap(newCampaign => {
      const id = newCampaign.get('id')
      const oldCampaign = selectors.campaign(id)(getState())
      const operations = patchOperations(newCampaign.toJS(), oldCampaign.toJS())
      return api
        .update(id, operations)
        .map(actions.receiveCampaign)
        .startWith(actions.updateCampaignPending({ id }))
        .catch(error => {
          app.actions.NotificationActions.pushNotification({
            content: "We’re having trouble updating your campaign right now. Please try again in a bit.",
            variant: 'red',
          })
          captureException(error)
          return Observable.of(actions.updateCampaignFailed({ id, error }))
        })
    })
}

function searchCampaigns(action$) {
  return action$.ofType(actions.searchCampaigns.toString())
    .debounceTime(200)
    .switchMap(action => {
      const { query = "" , limit } = action.payload

      return api
        .search(query, { limit })
        .takeUntil(action$.ofType(actions.searchCampaignsCancelled.toString()))
        .map(actions.searchCampaignsSuccess)
        .startWith(actions.searchCampaignsPending())
        .catch(error => {
          captureException(error)
          return Observable.of(actions.searchCampaignsFailed(error))
        })
    })
}

function loadMoreCampaigns(action$, { getState }) {
  return action$.ofType(actions.loadMoreCampaigns.toString())
    .switchMap(() => {
      const state = getState()
      const query = selectorsUI.query(state)
      const offset = selectors.searchResults(state).size
      return api
        .fetch(query, { offset })
        .takeUntil(action$.ofType(actions.searchCampaigns.toString()))
        .map(actions.loadMoreCampaignsSuccess)
        .startWith(actions.loadMoreCampaignsPending())
        .catch(error => {
          captureException(error)
          return Observable.of(actions.loadMoreCampaignsFailed(error))
        })
    })
}

function pushCampaign(action$, store) {
  return action$
    .ofType(SocketConstants.JOIN_CHANNEL_PENDING)
    .pluck('payload')
    .filter((payload) => payload.clusterName === SocketConstants.SocketCluster.MESSAGES)
    .filter((payload) => payload.channelName === SocketConstants.SocketChannel.ORG_PRIVATE)
    .switchMap(({ channel, leaveChannel$ }) => {
      return Observable.create((observer) => {
        channel.on('campaign-updated', (payload) => {
          app.actions.CampaignActions.pushCampaign(payload)
        })
      })
        .takeUntil(leaveChannel$)
    })
}


export const epic = combineEpics(
  fetchCampaign,
  updateCampaign,
  searchCampaigns,
  loadMoreCampaigns,
  pushCampaign,
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/epic.js